import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import './style.scss';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="notfound__container">
      <span className="notfound__number">404</span>
      <span className="notfound__title">ページが見つかりません</span>
      <span className="notfound__subtitle">おっと！お探しのページは存在しません</span>

      <Button className="notfound__button" onClick={() => navigate('/')}>
        ホームに戻る
      </Button>
    </div>
  );
};

export default NotFound;
